import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

// Paleta semántica fija (tokens.json, fixed:true). NO override por tenant.
const TONES = {
  ok: { color: '#2e6b3a', bg: '#eaf2ec', border: '#cfe5d4' },
  err: { color: '#9b2a1e', bg: '#f6e9e7', border: '#e7c6c1' },
  warn: { color: '#c5561d', bg: '#f8ede4', border: '#eed6c4' },
  signal: { color: '#b8861a', bg: '#f6efda', border: '#ead9ad' },
  info: { color: '#1b4f72', bg: '#e8eef4', border: '#c8d6e0' },
};

function StatusTag({ tone, children }) {
  const t = TONES[tone] || TONES.info;
  const styles = StyleSheet.create({
    tag: {
      alignSelf: 'flex-start',
      flexDirection: 'row',
      backgroundColor: t.bg,
      border: `1px solid ${t.border}`,
      borderRadius: 99,
      paddingVertical: 2,
      paddingHorizontal: 7,
    },
    label: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: t.color },
  });
  return (
    <View style={styles.tag}>
      <Text style={styles.label}>{children}</Text>
    </View>
  );
}

export default StatusTag;
